import { createServerFn } from '@tanstack/react-start'

export const getAdminDocuments = createServerFn({ method: 'GET' }).handler(
  async () => (await import('@server/admin-functions')).getAdminDocuments(),
)

export const removeDocument = createServerFn({ method: 'POST' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).removeDocument({ data }),
)

export const addRagDocumentsStream = createServerFn({ method: 'POST' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).addRagDocumentsStream({ data }),
)

export const createAdminRagDocumentUpload = createServerFn({
  method: 'POST',
}).handler(async ({ data }) =>
  (await import('@server/admin-functions')).createAdminRagDocumentUpload({
    data,
  }),
)

export const getAdminRagRevisionDetail = createServerFn({
  method: 'POST',
}).handler(async ({ data }) =>
  (await import('@server/admin-functions')).getAdminRagRevisionDetail({ data }),
)

export const getAdminRagRevisionWorkflow = createServerFn({
  method: 'POST',
}).handler(async ({ data }) =>
  (await import('@server/admin-functions')).getAdminRagRevisionWorkflow({
    data,
  }),
)

export const queueAdminRagSkipPageReview = createServerFn({
  method: 'POST',
}).handler(async ({ data }) =>
  (await import('@server/admin-functions')).queueAdminRagSkipPageReview({
    data,
  }),
)

export const queueAdminRagIngest = createServerFn({ method: 'POST' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).queueAdminRagIngest({ data }),
)

export const submitAdminRagSkipPagesAndIngest = createServerFn({
  method: 'POST',
}).handler(async ({ data }) =>
  (await import('@server/admin-functions')).submitAdminRagSkipPagesAndIngest({
    data,
  }),
)

export const submitAdminRagPageReviewAndStartIngest = createServerFn({
  method: 'POST',
}).handler(async ({ data }) =>
  (
    await import('@server/admin-functions')
  ).submitAdminRagPageReviewAndStartIngest({
    data,
  }),
)

export const submitAdminRagChunkReviewAndResume = createServerFn({
  method: 'POST',
}).handler(async ({ data }) =>
  (await import('@server/admin-functions')).submitAdminRagChunkReviewAndResume({
    data,
  }),
)

export const retryAdminRagIngest = createServerFn({ method: 'POST' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).retryAdminRagIngest({ data }),
)

export const searchAdminRagRevision = createServerFn({
  method: 'POST',
}).handler(async ({ data }) =>
  (await import('@server/admin-functions')).searchAdminRagRevision({ data }),
)

export const getGlobalPlans = createServerFn({ method: 'GET' }).handler(
  async () => (await import('@server/admin-functions')).getGlobalPlans(),
)

export const createGlobalPlan = createServerFn({ method: 'POST' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).createGlobalPlan({ data }),
)

export const updateGlobalPlan = createServerFn({ method: 'POST' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).updateGlobalPlan({ data }),
)

export const deleteGlobalPlan = createServerFn({ method: 'POST' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).deleteGlobalPlan({ data }),
)

export const getAdminUsers = createServerFn({ method: 'GET' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).getAdminUsers({ data }),
)

export const getAdminUserPrompts = createServerFn({ method: 'GET' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).getAdminUserPrompts({ data }),
)

export const getAdminConversationTranscript = createServerFn({
  method: 'POST',
}).handler(async ({ data }) =>
  (await import('@server/admin-functions')).getAdminConversationTranscript({
    data,
  }),
)

export const getAdminFeedback = createServerFn({ method: 'GET' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).getAdminFeedback({ data }),
)

export const updateAdminFeedbackStatus = createServerFn({
  method: 'POST',
}).handler(async ({ data }) =>
  (await import('@server/admin-functions')).updateAdminFeedbackStatus({ data }),
)

export const adminDeleteConversation = createServerFn({
  method: 'POST',
}).handler(async ({ data }) =>
  (await import('@server/admin-functions')).adminDeleteConversation({ data }),
)

export const getAdminOrganizations = createServerFn({ method: 'GET' }).handler(
  async () => (await import('@server/admin-functions')).getAdminOrganizations(),
)

export const getAdminUserDetails = createServerFn({ method: 'POST' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).getAdminUserDetails({ data }),
)

export const getAdminOrganizationDetails = createServerFn({
  method: 'POST',
}).handler(async ({ data }) =>
  (await import('@server/admin-functions')).getAdminOrganizationDetails({
    data,
  }),
)

export const adminRevokeSession = createServerFn({ method: 'POST' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).adminRevokeSession({ data }),
)

export const adminRemoveOrgMember = createServerFn({ method: 'POST' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).adminRemoveOrgMember({ data }),
)

export const adminAddOrgMember = createServerFn({ method: 'POST' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).adminAddOrgMember({ data }),
)

export const adminRemoveUser = createServerFn({ method: 'POST' }).handler(
  async ({ data }) =>
    (await import('@server/admin-functions')).adminRemoveUser({ data }),
)

export const updateAdminUserDetails = createServerFn({
  method: 'POST',
}).handler(async ({ data }) =>
  (await import('@server/admin-functions')).updateAdminUserDetails({ data }),
)

export const updateAdminOrganizationDetails = createServerFn({
  method: 'POST',
}).handler(async ({ data }) =>
  (await import('@server/admin-functions')).updateAdminOrganizationDetails({
    data,
  }),
)

export const getAdminStats = createServerFn({ method: 'GET' }).handler(
  async () => (await import('@server/admin-functions')).getAdminStats(),
)

export const getAdminSubscribers = createServerFn({ method: 'GET' }).handler(
  async () => (await import('@server/admin-functions')).getAdminSubscribers(),
)
